// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"245b8120","353":"b96b18de","518":"88afdff0","620":"e1621ee6"}[chunkId] + ".chunk.css";
};